import $ from 'jquery';
import 'arrive';

$(document).ready(function () {
    document.arrive('.srg-wwu-list-container', {existing: true}, function () {
        let $block = $(this);
        if ($(window).width() < 992) {
            $block.find('.content-block').click(function() {
                $(this).parent().toggleClass('active');
            });
        }
    });
    document.arrive('.aw_applyLink', {existing: true}, function () {
        let $btn = $(this);
        $btn.click(function(e) {
            e.stopPropagation();
        })
    });
});